class TeamModalPopUp {
    constructor() {
      this.filterAElm = document.querySelectorAll('.card-team-btn');
      this.events();
    }
    modalPopUpAjax(postID) {

        const request = new XMLHttpRequest();
      
        let data = `action=teamModalPopUp&postID=${postID}`;
    
        request.open('POST', orr_ajax_object.ajaxurl, true);
        request.setRequestHeader(
            'Content-Type',
            'application/x-www-form-urlencoded; charset=UTF-8'
        );
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                var content = JSON.parse(this.response);
                if( content.hasQuote )
                {
                    document.getElementById('teamDetailModal').classList.add('hasQuote');
                }
                else
                {
                    document.getElementById('teamDetailModal').classList.remove('hasQuote');
                }
                document.querySelector('.modal-team .modal-content').innerHTML = content.content;
            } else {
            console.log(this.status);
            }
        };
        request.onerror = function () {
            // Connection error
            console.log('error');
        };
        request.send(data);
    }

    click() {
        this.filterAElm.forEach((element) => {
        element.addEventListener('click', (e) => {
            e.preventDefault();
                var dataId = e.target.getAttribute('data-postid');
                $("#teamDetailModal").modal("show");
                this.modalPopUpAjax(dataId);
            });
        });
    }
   
    events() {
      this.click();
    }
  }
  
  export default TeamModalPopUp;
  new TeamModalPopUp();
  